<template>
  <div>
    <div v-if="!disabled" class="d-flex justify-content-end mb-1">
      <action-button
        class="success"
        i="fas fa-save"
        text="Guardar"
        @click="save"
      />
    </div>

    <div
      v-if="!disabled && !canSearch"
      class="d-flex justify-content-center mt-5 bg-secondary-13"
    >
      <div class="w-35 py-3">
        <div class="d-flex justify-content-center">
          <action-button
            class="border w-100 btn"
            i="fas fa-file-plus color-primary-1"
            text="Presione aquí para añadir Practicantes/Internos/Especialistas"
            @click="isSearchVisible = true"
          />
        </div>
      </div>
    </div>
    <search
      v-if="canSearch"
      :disabled="disabled"
      :on-specialist-selected="handleSpecialistSelected"
      :selected-specialist="selectedSpecialistIds"
    />
    <add
      v-model="selectedSpecialists"
      :disabled="disabled"
      :on-remove-specialist="handleRemoveSpecialist"
    />
    <div v-if="disabled && selectedSpecialistIds.length == 0">
      <div class="col-12 p-4 text-center align-items-center no-info mt-4">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-1 align-self-center">
            <i class="far fa-folder-open icon no-info-icon pl-2" />
          </div>
          <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
            <span class="no-info-text">
              El especialista no cuenta con información de Supervisión.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './Search';
import Add from './Add';
import storeMixin from '@/shared/mixins/storeGenerator';
import alert from '@/mixins/alert.mixin';
import {
  getSupervisedInfo,
  saveSupervised,
  needToCreateNewExemption,
} from '@/modules/provider/api.js';
import { mapState } from 'vuex';

import supervisedTypes from '@/utils/constants/supervisedTypes.js';

export default {
  name: '',
  components: {
    Search,
    Add,
  },
  mixins: [storeMixin, alert],
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedSpecialists: [],
      isSearchVisible: false,
      specialistAdded: false,
      specialistRemoved: false,
    };
  },
  computed: {
    ...mapState('$_user', ['user']),
    specialistId() {
      return parseInt(this.$route.params.specialistId);
    },
    companyId() {
      return (
        parseInt(this.user.profile.companyid) || this.$route.params.companyId
      );
    },
    fiscalYearId() {
      let _fiscalYearId = parseInt(this.$route.params.fiscalYearId);
      return _fiscalYearId;
    },
    canSearch() {
      return this.isSearchVisible;
    },
    selectedSpecialistIds() {
      const idList = this.selectedSpecialists.map((x) => x.supervisedId);
      return idList;
    },
  },
  watch: {
    selectedSpecialists() {
      const result = this.selectedSpecialists.slice();

      this.persistLazyData({ supervisedList: result });
    },
  },
  async created() {
    if (this.specialistId) {
      getSupervisedInfo(
        this.specialistId,
        this.fiscalYearId,
        this.companyId
      ).then(({ data }) => {
        this.selectedSpecialists = data;
      });
    }
  },
  methods: {
    async save() {
      const model = {
        specialistId: this.specialistId,
        companyId: this.companyId,
        specialistSupervisions: this.selectedSpecialists,
      };

      if (model.specialistSupervisions.length === 0 && !this.specialistRemoved)
        return;

      let supervisedSpecialists = model.specialistSupervisions.filter(
        (x) => x.supervisedType == supervisedTypes.Specialist
      );

      const anyTouchedSpecialistType = supervisedSpecialists.some(
        (x) => x.isSelected
      );

      if (supervisedSpecialists.length > 0 && anyTouchedSpecialistType) {
        const { data: doesNeedNewExemption } = await needToCreateNewExemption(
          model.companyId,
          model.specialistId,
          this.fiscalYearId,
          supervisedSpecialists.map((x) => x.supervisedId)
        ).catch((err) => {
          const errorMessage =
            err && err.response && err.response.data
              ? err.response.data.message
              : err.message;
          this.ShowToast('Error', errorMessage, 'error');
        });

        if (doesNeedNewExemption && this.specialistAdded == true) {
          let response = await this.ShowCancelModal(
            'Atención',
            "<p class='font-weight-bold'>La cantidad de Personal Supervisado, sobrepasa el límite permitido.</p> De necesitar una <span class='font-weight-bold'>Dispensa</span> para Supervisar al Personal seleccionado, presione Sí. De lo contrario presione No y elimine el personal hasta lograr el límite permitido. ",
            'Si',
            'No'
          );

          if (response) {
            this.$router.push({
              name: 'dispensation-request',
              params: {
                ...model,
                specialistSupervisions: supervisedSpecialists.map((x) => ({
                  supervisedType: x.supervisedType,
                  supervisedId: x.supervisedId,
                })),
                academicYearId: this.fiscalYearId,
              },
            });
          }

          return;
        }
      }

      model.companyId = +model.companyId;
      model.academicYearId = +this.fiscalYearId;
      saveSupervised(model)
        .then(() => {
          this.ShowToast('', 'Proceso guardado exitosamente', 'success');
          this.specialistAdded = false;
          this.specialistRemoved = false;
        })
        .catch(() => {
          this.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          );
        });
    },
    handleSpecialistSelected(specialist) {
      specialist.isSelected = true;
      this.specialistAdded = true;
      const found = this.selectedSpecialists.find(
        (x) => x.supervisedId === specialist.supervisedId
      );
      if (!found) {
        if (specialist.socialSecurity) {
          let ssnLastDigits = specialist.socialSecurity.substr(-4);
          specialist.socialSecurity = `xxx-xx-${ssnLastDigits}`;
        }

        this.selectedSpecialists.push(specialist);

        // order selected specialists by name
        this.selectedSpecialists.sort((a, b) => {
          if (a.specialistName > b.specialistName) return 1;
          if (a.specialistName < b.specialistName) return -1;

          return 0;
        });
      }
    },
    handleRemoveSpecialist(specialistId) {
      this.specialistRemoved = true;
      const index = this.selectedSpecialists.findIndex(
        (x) => x.supervisedId === specialistId
      );

      this.selectedSpecialists.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
  .no-info-text {
    text-align: left;
    font: Bold 16px/22px Lato;
    letter-spacing: 0;
    color: #727272;
    opacity: 1;
  }
  .no-info-icon {
    color: #727272;
    font-size: 32px;
  }
}
</style>
